var exports = {
  "EU": "CellFrame__GHvvbb",
  "nB": "Body__yg6wuR",
  "xx": "ScrollFades__5zP0QA",
  "CW": "Cards__Iz2lWl",
  "Sv": "Empty__KQ74hI",
};

module.exports = exports;
